
import { Component, Vue, Prop } from 'vue-property-decorator';
import { VNode } from 'vue';

/**
 * 外部容器
 *
 * 如果两页滑动的情况下
 *  - containerPageCount 3 总共3页
 *  - contentPageCount 2 2页内容滑动
 *  - containerPageIndex 1 当前显示页1
 *  - contentPageOffset 1 向左偏移页1
 */
@Component({
    name: 'HorizontalSlideContainer',
})
export default class HorizontalSlideContainer extends Vue {
    /** 当前显示页面 */
    @Prop({ required: true, type: Number }) public current!: number;
    /** 总页面数量 */
    @Prop({ required: true, type: Number }) public containerPageCount!: number;
    /** 内容页面数量 */
    @Prop({ required: true, type: Number }) public contentPageCount!: number;
    /** 容器当前显示第几页，以页为单位，例如为1的情况，则默认显示为第1页，默认为0 */
    @Prop({ required: true, type: Number, default: 0 }) public containerPageIndex!: number;
    /** 内容偏移，内容默认从container的第0页开始显示 */
    @Prop({ required: true, type: Number, default: 0 }) public contentPageOffset!: number;

    /**
     * 容器当前显示第几页，单位为%
     */
    public get containerPageX() {
        return -(this.containerPageIndex / this.containerPageCount * 100).toFixed(4) + '%';
    }
    /**
     * 内容当前在容器的第几页开始，单位为%
     */
    public get contentPageLeft() {
        return (this.contentPageOffset / this.containerPageCount * 100).toFixed(4) + '%';
    }
    /**
     * %
     */
    public get contentPageWidth() {
        return (this.contentPageCount / this.containerPageCount * 100).toFixed(4) + '%';
    }
    /**
     * 每一页的宽度
     */
    public get slidePageWidth() {
        return (1 / this.contentPageCount * 100).toFixed(4) + '%';
    }

    // @ts-ignore
    public render(h) {
        const vm = this;
        // @ts-ignore
        const pages = this.$slots.default.filter((vnode) => {
            //  && vnode.tag.indexOf('SwiperSlide') != -1
            return vnode != null && vnode.tag != null;
        });
        // 处理所有的slidePage
        pages.forEach((page: VNode) => {
            if (!page.data) {
                page.data = {
                    style: {
                        width: vm.slidePageWidth,
                    },
                };
            }
            if (!page.data.style) {
                page.data.style = {
                    width: vm.slidePageWidth,
                };
                return;
            }
            // @ts-ignore
            page.data.style.width = vm.slidePageWidth;
        });

        const slideContent = h('div', {
            class: [ 'horizontal-slide-content', 'clearfix' ],
            style: {
                left: this.contentPageLeft,
                width: this.contentPageWidth,
                transform: `translate3d(-${(this.current * 1 / this.contentPageCount * 100).toFixed(4) + '%'}, 0, 0)`,
            },
        }, pages);

        const slideContainer = h('div', {
            class: [ 'horizontal-slide-container' ],
            style: {
                width: this.containerPageCount + '00%',
                transform: 'translate3d(' + this.containerPageX + ', 0, 0)',
            },
        }, [ slideContent ]);

        const slideWrap = h('div', {
            class: [ 'horizontal-slide-wrap' ],
        }, [ slideContainer ]);

        return slideWrap;
    }
}
